/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import ViewVR from "App/view/view_vr";
import CameraStereo from "App/view/cameras/camera_stereo";

export default
class ViewStereo extends ViewVR {
    constructor(aViewMode, aDocument, aPositionPct, aSizePct) {
        super(aViewMode, aDocument, aPositionPct, aSizePct);
    }

    protected _renderLeft() {
        this.position = this.positionL;
        this.size = this.sizeL;

        // set camera parameters for left stereo view
        let camera = this._controls.getCamera() as CameraStereo;

        camera.setFieldOfView(0.785);
        camera.setAspectRatio(this.size[0] / this.size[1]);
        camera.setRenderingLeftView();

        this.document.render(this);
    }

    protected _renderRight() {
        this.position = this.positionR;
        this.size = this.sizeR;

        // set camera parameters for right stereo view
        let camera = this._controls.getCamera() as CameraStereo;

        camera.setFieldOfView(0.785);
        camera.setAspectRatio(this.size[0] / this.size[1]);
        camera.setRenderingRightView();

        this.document.render(this);
    }
}
